<template>
    <div
        v-for="tag in availableTags"
        class="
            text-xs
            p-2
            rounded-full
            inline-flex
            items-center
            w-auto
            gap-2
            cursor-pointer
        "
        :class="[
            activeTags[tag.id]
                ? 'opacity-100 hover:opacity-75'
                : 'opacity-25 hover:opacity-75',
        ]"
        :style="{
            background: tag.color,
            color: isDark(tag.color) ? '#fff' : '#000',
        }"
        @click="toggleTag(tag.id)"
    >
        <img
            v-if="tag.icon_type === 'upload'"
            :src="tag.icon"
            alt=""
            class="w-[15px] h-[15px]"
        />
        <div v-if="tag.icon_type === 'emoji'">{{ tag.icon }}</div>
        <ion-icon
            v-if="tag.icon_type === 'ionicons'"
            :name="tag.icon"
        ></ion-icon>
        <span>{{ tag.name }}</span>
    </div>
    <input type="hidden" name="tags" :value="JSON.stringify(tagFormValue)" />
</template>

<script setup>
import { isDark } from "./forms/utils";
import { computed, reactive } from "vue";

const props = defineProps({
    tags: {
        type: Array,
        required: false,
        default: [],
    },
    availableTags: {
        type: Array,
        required: true,
        default: [],
    },
});

const activeTags = reactive(
    props.availableTags.reduce((acc, tag) => {
        if (
            props.tags &&
            props.tags.find(
                (backendActiveTag) => backendActiveTag.id === tag.id
            )
        ) {
            acc[tag.id] = true;
        }
        return acc;
    }, {})
);

const tagFormValue = computed(() => {
    return props.availableTags
        .filter((tag) => activeTags[tag.id])
        .map((tag) => tag.id);
});

function toggleTag(id) {
    activeTags[id] = !activeTags[id];
}
</script>

<style scoped></style>
